import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { IoMdInformationCircleOutline } from 'react-icons/io';

const TableCell = ({ cell, onClick, onKeyDown, displayRowCount }) => {
  const [tip, setTip] = useState('');
  const renderedCell = useRef(null);

  const cellProps = cell.getCellProps();

  useEffect(() => {
    if (renderedCell.current && renderedCell.current.offsetWidth < renderedCell.current.scrollWidth && cell.column.id !== "status") {
      setTip(cell.value);
    }
  }, [cell, cellProps.style]);

  return onClick === null || cell.render('Cell') === '' ? (
    <div
      className={`table__item table__item--${cell.column.id}`}
      data-tip={tip}
      style={cellProps.style}
      data-sticky-last-left-td={cellProps['data-sticky-last-left-td'] !== undefined ? cellProps['data-sticky-last-left-td'] : null}
      data-sticky-td={cellProps['data-sticky-td'] !== undefined ? cellProps['data-sticky-td'] : null}
      role="cell"
    >
      <div ref={renderedCell}>
        {displayRowCount > 0 && `${displayRowCount}. `}
        {cell.render('Cell')}
      </div>
    </div>
  ) : (
    <div
      ref={renderedCell}
      className={`table__item table__item--${cell.column.id} clickable`}
      data-tip={tip}
      style={cellProps.style}
      data-sticky-last-left-td={cellProps['data-sticky-last-left-td'] !== undefined ? cellProps['data-sticky-last-left-td'] : null}
      data-sticky-td={cellProps['data-sticky-td'] !== undefined ? cellProps['data-sticky-td'] : null}
      role="button"
      tabIndex="0"
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <div ref={renderedCell}>
        {displayRowCount > 0 && `${displayRowCount}. `}
        {cell.render('Cell')}
      </div>
      <IoMdInformationCircleOutline data-tip="View Contact Details" />
    </div>
  );
};

TableCell.defaultProps = {
  onClick: null,
  onKeyDown: null,
  displayRowCount: 0,
};

TableCell.propTypes = {
  cell: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  displayRowCount: PropTypes.number,
};

export default TableCell;
